import { render } from "./ChatListComponent.vue?vue&type=template&id=1d230baa&scoped=true"
import script from "./ChatListComponent.vue?vue&type=script&lang=js"
export * from "./ChatListComponent.vue?vue&type=script&lang=js"

import "./ChatListComponent.vue?vue&type=style&index=0&id=1d230baa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d230baa"]])

export default __exports__